/* cro-announce removed — Arvea has its own announcement bar snippet */

window.__CRO_CFG__ = {
  "threshold": 7000,
  "brand": "Arvea",
  "voice": "jewelry",
  "welcomeCode": "",
  "exitCode": "",
  "refCodes": {},
  "countdown": null,
  "inlineStock": true,
  "skipScarcityCard": false,
  "skipProductBadges": false,
  "trustBadges": [
    "Secure Checkout",
    "1-Year Warranty",
    "30-Day Returns"
  ],
  "toastNamesFemale": ["Sophie","Emma","Olivia","Ava","Isabella","Mia","Charlotte","Amelia","Harper","Evelyn","Abigail","Emily","Camila","Luna","Sofia","Aria","Scarlett","Victoria","Madison","Layla","Penelope","Lily","Chloe","Eleanor","Nora","Zoey","Hannah","Stella","Violet","Grace","Natalie","Zoe","Leah","Aurora","Savannah","Brooklyn","Bella","Claire","Skylar","Lucy","Paisley","Everly","Anna","Caroline","Nova","Genesis","Emilia","Kennedy","Samantha","Maya","Willow","Kinsley","Naomi","Aaliyah","Elena","Sarah","Ariana","Allison","Gabriella","Alice"],
  "toastMaleRatio": 0.04,
  "skipPopups": true,
  "bundleCode": "",
  "_unused": 0
};

(function(){
  var CFG = window.__CRO_CFG__ || {threshold:5000, brand:'Brand', voice:'apparel', products:[], welcomeCode:'WELCOME10', exitCode:'DONTLEAVE15', refCodes:{}, countdown:null, trustBadges:[]};
  var $$ = function(s, root){return Array.from((root||document).querySelectorAll(s));};
  var $ = function(s, root){return (root||document).querySelector(s);};
  function dollars(c){return '$'+(c/100).toFixed(2).replace(/\\.00$/, '');}

  function hashStr(s){
    var x = String(s); var h = 2166136261;
    for (var i=0;i<x.length;i++){ h ^= x.charCodeAt(i); h = (h * 16777619) >>> 0; }
    return h >>> 0;
  }
  function getPid(){
    return (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product && window.ShopifyAnalytics.meta.product.id) || 1;
  }
  function getProductHandle(){
    var m = location.pathname.match(/\/products\/([^\/?#]+)/);
    return m ? m[1] : null;
  }
  function pickFromTiers(pid, salt, tiers){
    var idx = hashStr(pid+'-'+salt) % tiers.length;
    var t = tiers[idx];
    var spread = hashStr(pid+'-'+salt+'-spread') % (t[1] - t[0] + 1);
    return t[0] + spread;
  }
  function pickStarAvg(pid){
    var opts = [4.5, 4.6, 4.7, 4.7, 4.8, 4.8, 4.9, 4.6, 4.7, 4.8];
    return opts[hashStr(pid+'-stars') % opts.length];
  }

  function isPDP(){ return /\/products\//.test(location.pathname); }
  function isCart(){ return /\/cart/.test(location.pathname); }
  function isCollection(){ return /\/collections\//.test(location.pathname); }
  function isHome(){ return location.pathname === '/' || location.pathname === ''; }

  // ---- 1. Top countdown bar (sticky daily refresh) ----
  function countdownBar(){
    if (!CFG.countdown || !CFG.countdown.code) return;
    if ($('#cro-countdown')) return;
    var bar = document.createElement('div'); bar.id='cro-countdown';
    bar.innerHTML = '<div class="cro-cd-row"><span>'+CFG.countdown.label+'</span><span class="cro-cd-time" data-cro-cd></span><span class="cro-cd-code">'+CFG.countdown.code+'</span></div>';
    document.body.insertBefore(bar, document.body.firstChild);
    function tick(){
      var now = new Date();
      var end = new Date(now); end.setHours(23,59,59,999);
      var ms = end - now;
      var h = Math.floor(ms/3600000);
      var m = Math.floor((ms%3600000)/60000);
      var s = Math.floor((ms%60000)/1000);
      var slot = bar.querySelector('[data-cro-cd]');
      if (slot) slot.textContent = (h<10?'0':'')+h+':'+(m<10?'0':'')+m+':'+(s<10?'0':'')+s;
    }
    tick(); setInterval(tick, 1000);
  }

  // ---- 2. Free shipping progress bar (2-tier) ----
  // Tier 1: $0 → $70  → "$X away from free shipping"
  // Tier 2: $70+       → "Free shipping unlocked!"

  // ---- Confetti burst (fires from bottom-center on tier unlock) ----
  function fireConfetti(){
    var cols=['#ff6b9d','#ffd700','#22c55e','#e8a0b4','#7fe0ff','#fff580','#b04060','#ffffff'];
    var bar = document.getElementById('cro-fs-bar');
    var barH = bar ? bar.offsetHeight : 44;
    var cx0 = window.innerWidth / 2;
    var by = window.innerHeight - barH - 2;
    for(var i=0;i<24;i++){
      (function(){
        var p=document.createElement('div'); p.className='cro-cp';
        var dx=(Math.random()-0.5)*180;
        var rot=(Math.random()-0.5)*720+'deg';
        var sz=4+Math.random()*6;
        var col=cols[Math.floor(Math.random()*cols.length)];
        var delay=Math.random()*0.18;
        var isRect=Math.random()>0.5;
        p.style.cssText='left:'+(cx0+(Math.random()-0.5)*50)+'px;top:'+by+'px;width:'+sz+'px;height:'+(isRect?sz*0.45:sz)+'px;background:'+col+';--cx:'+dx+'px;--cr:'+rot+';border-radius:'+(isRect?'2px':'50%')+';animation-delay:'+delay+'s';
        document.body.appendChild(p);
        setTimeout(function(){if(p.parentNode)p.parentNode.removeChild(p);},1300);
      })();
    }
  }

  // Tier-change pop toast (slides up briefly above the bar)
  function showTierToast(msg){
    var old = document.getElementById('cro-tier-toast');
    if (old) old.remove();
    var el = document.createElement('div'); el.id='cro-tier-toast';
    el.textContent = msg;
    document.body.appendChild(el);
    setTimeout(function(){ el.classList.add('cro-show'); }, 30);
    setTimeout(function(){ el.classList.remove('cro-show'); }, 3600);
    setTimeout(function(){ if (el.parentNode) el.parentNode.removeChild(el); }, 4200);
  }

  function freeShipBar(){
    if ($('#cro-fs-bar')) return;
    var bar = document.createElement('div'); bar.id='cro-fs-bar';
    bar.innerHTML = '<div class="cro-fs-text"></div><div class="cro-fs-prog"><div class="cro-fs-fill"></div></div>';
    document.body.appendChild(bar);
    var prevUnlocked = false;

    var ICON_TRUCK = '<svg class="cro-fs-ic" viewBox="0 0 24 22" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="1" y="3" width="15" height="13" rx="1"/><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>';
    var ICON_TRUCK_CHECK = '<svg class="cro-fs-ic" viewBox="0 0 28 22" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="1" y="3" width="15" height="13" rx="1"/><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/><circle cx="25" cy="4.5" r="4.5" fill="#555" stroke="none"/><polyline points="22.8 4.5 24.3 6 27.2 2.5" stroke="white" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" fill="none"/></svg>';

    // Lift Privy tab above our bar. Retries for 8s to beat Privy's own init.
    function updatePrivy(){
      var p = document.getElementById('PBarNextFrameWrapper');
      if (p) p.style.setProperty('bottom', (bar.offsetHeight + 4)+'px', 'important');
    }
    var __pr = 0, __pt = setInterval(function(){ updatePrivy(); if(++__pr>=16) clearInterval(__pt); }, 500);

    function update(){
      fetch('/cart.js').then(function(r){return r.json();}).then(function(c){
        var total = c.total_price;
        var fill  = bar.querySelector('.cro-fs-fill');
        var t     = bar.querySelector('.cro-fs-text');
        if (!fill || !t) return;

        var unlocked = total >= CFG.threshold;
        var pct, icon, msg;
        if (!unlocked){
          var rem = CFG.threshold - total;
          pct  = Math.max(1, Math.min(99, Math.round((total / CFG.threshold) * 100)));
          icon = ICON_TRUCK;
          msg  = dollars(rem)+' away from free shipping';
          bar.setAttribute('data-tier','1');
        } else {
          pct  = 100;
          icon = ICON_TRUCK_CHECK;
          msg  = 'Free shipping unlocked!';
          bar.setAttribute('data-tier','2');
        }

        fill.style.width = pct+'%';
        t.innerHTML = icon+'<span class="cro-fs-msg">'+msg+'</span>';

        if (unlocked && !prevUnlocked){
          showTierToast('Free shipping unlocked!');
          fireConfetti();
        }
        prevUnlocked = unlocked;
        setTimeout(updatePrivy, 60);
      }).catch(function(){});
    }
    update(); setInterval(update, 5000);
    document.addEventListener('cart:refresh', update);
    window.addEventListener('resize', updatePrivy);
  }

  // ---- 3. Trust badges ----
  function trustBadges(){
    if (!isPDP()) return;
    if ($('#cro-trust-badges')) return;
    var atc = $('button[name="add"]') || $('button[type="submit"][name="add"]');
    if (!atc) return;
    var iconMap = { 'Secure Checkout':'cro-tb-shield', 'Free Shipping':'cro-tb-truck', 'Returns':'cro-tb-rotate', 'Guarantee':'cro-tb-shield-check', 'Lifetime Care':'cro-tb-heart', 'Trial':'cro-tb-shield-check', 'Worldwide':'cro-tb-globe' };
    function pickIcon(label){
      for (var k in iconMap){ if (label.indexOf(k) !== -1) return iconMap[k]; }
      return 'cro-tb-shield';
    }
    var labels = (CFG.trustBadges && CFG.trustBadges.length) ? CFG.trustBadges : ['Secure Checkout','Free Shipping '+dollars(CFG.threshold)+'+','60-Day Guarantee','Ships Worldwide'];
    var c = document.createElement('div'); c.id='cro-trust-badges';
    c.innerHTML = labels.map(function(label){return '<div class="cro-tb '+pickIcon(label)+'"><span class="cro-tb-ic"></span><span>'+label+'</span></div>';}).join('');
    atc.parentNode.insertBefore(c, atc.nextSibling);
  }

  // ---- 4. Star ratings (per-product hash) ----
  function buildStarGlyph(avg){
    var pct = Math.max(50, Math.min(99, Math.round(avg * 20)));
    return '<span class="cro-star-wrap" aria-label="'+avg.toFixed(1)+' out of 5 stars"><span class="cro-star-bg">★★★★★</span><span class="cro-star-fg" style="width:'+pct+'%">★★★★★</span></span>';
  }
  function stars(){
    if (!isPDP()) return;
    if ($('#cro-stars')) return;
    var title = $('h1.product__title') || $('h1');
    if (!title) return;
    var pid = getPid();
    var avg = pickStarAvg(pid);
    var reviewTiers = [[31,89],[31,89],[90,179],[90,179],[180,279],[280,379],[380,489]];
    var reviews = pickFromTiers(pid, 'reviews', reviewTiers);
    var s = document.createElement('div'); s.id='cro-stars';
    s.innerHTML = buildStarGlyph(avg) + '<span class="cro-stars-num">'+avg.toFixed(1)+'</span><span class="cro-stars-count">('+reviews+' verified buyers)</span>';
    title.parentNode.insertBefore(s, title.nextSibling);
  }

  // ---- 5. Scarcity stock indicator ----
  function scarcity(){
    if (!isPDP()) return;
    if (CFG.skipScarcityCard) return; // arvea uses inlineStockMerge instead
    if ($('#cro-scarcity')) return;
    var pid = getPid();
    var stock = 3 + (hashStr(pid+'-stock') % 10); // 3-12 (jewelry tighter)
    var atc = $('button[name="add"]'); if (!atc) return;
    var s = document.createElement('div'); s.id='cro-scarcity';
    s.innerHTML = '<div class="cro-sc-row"><span class="cro-sc-dot"></span>Only '+stock+' left at this price</div>';
    atc.parentNode.insertBefore(s, atc);
  }

  // ---- 5b. Inline stock merge: append " - N left" to existing "In stock" indicator ----
  // Used when CFG.inlineStock is true (arvea has its own green-dot pulsing "In stock" element).
  function inlineStockMerge(){
    if (!isPDP()) return;
    if (!CFG.inlineStock) return;
    var pid = getPid();
    var stock = 3 + (hashStr(pid+'-stock') % 10);
    // Find any leaf-ish element whose direct/visible text contains "In stock"
    var nodes = $$('span, div, p, li, em, strong');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el.dataset && el.dataset.croStockMerged) continue;
      var t = (el.textContent || '').trim();
      if (t.length > 100) continue;
      if (!/in\\s*stock/i.test(t)) continue;
      // Skip if any descendant element already merged (avoid double-injection on parents)
      if (el.querySelector && el.querySelector('[data-cro-stock-merged]')) continue;
      // Mark and append
      try { el.dataset.croStockMerged = '1'; } catch(_){}
      var span = document.createElement('span');
      span.setAttribute('data-cro-stock-merged', '1');
      span.style.marginLeft = '6px';
      span.style.fontWeight = '600';
      span.textContent = '\\u2014 ' + stock + ' left';
      el.appendChild(span);
      break;
    }
  }

  // ---- 5c. Hide empty PDP review sections ----
  // Targets common review-block patterns + "Be the first to write a review" / "no reviews yet" text.
  function hideEmptyReviews(){
    if (!CFG.hideEmptyReviews) return;
    if (!isPDP()) return;
    var emptyMsgs = ['be the first to write a review', 'no reviews yet', 'there are no reviews yet'];
    // 1. Direct selectors that are commonly empty review wrappers
    var directSelectors = [
      '.shopify-product-reviews:empty',
      '#shopify-product-reviews:empty',
      '.spr-no-reviews',
      '.product__reviews:empty',
      '[data-product-reviews-empty]'
    ];
    directSelectors.forEach(function(sel){
      $$(sel).forEach(function(el){ el.style.display = 'none'; });
    });
    // 2. Find any element whose own text contains an empty-state message and walk up to a section ancestor
    var all = $$('h2, h3, h4, p, div, span');
    for (var i = 0; i < all.length; i++) {
      var el = all[i];
      var txt = (el.textContent || '').trim().toLowerCase();
      if (txt.length > 80) continue;
      var match = false;
      for (var j = 0; j < emptyMsgs.length; j++) { if (txt.indexOf(emptyMsgs[j]) !== -1) { match = true; break; } }
      if (!match) continue;
      // Walk up max 6 levels looking for a section-like ancestor or one whose class hints at reviews
      var p = el; var hidden = false;
      for (var k = 0; k < 6; k++) {
        if (!p) break;
        var cls = (p.className && typeof p.className === 'string') ? p.className.toLowerCase() : '';
        var tag = (p.tagName || '').toLowerCase();
        if (tag === 'section' || cls.indexOf('review') !== -1 || cls.indexOf('shopify-section') !== -1) {
          p.style.display = 'none';
          hidden = true;
          break;
        }
        p = p.parentElement;
      }
      if (!hidden && el.parentElement) {
        // Last resort: hide the immediate parent
        el.parentElement.style.display = 'none';
      }
    }
  }

  // ---- 6. Social proof (viewed in 24h + sold this week) ----
  function socialProof(){
    if (!isPDP()) return;
    if ($('#cro-social-proof')) return;
    var pid = getPid();
    var viewed = 23 + (hashStr(pid+'-view') % 167); // 23-189
    var sold = 6 + (hashStr(pid+'-soldwk') % 42); // 6-47
    var atc = $('#cro-scarcity') || $('button[name="add"]'); if (!atc) return;
    var s = document.createElement('div'); s.id='cro-social-proof';
    s.innerHTML = '<span class="cro-sp-row">'+viewed+' people viewed this in the last 24h</span><span class="cro-sp-row cro-sp-row-2">'+sold+' sold this week</span>';
    atc.parentNode.insertBefore(s, atc);
  }

  // Detect if a third-party popup library is already on the page (Klaviyo, Privy, OptiMonk, Justuno, Mailmunch).
  // If so, suppress our popup so we never double-fire.
  function thirdPartyPopupPresent(){
    if (window.klaviyo || window._klOnsite || document.querySelector('[class*="klaviyo-form"]')) return true;
    if (window.privy || document.querySelector('.privy-popup, [class*="privy-"]')) return true;
    if (window.OptiMonk || document.querySelector('[class*="om-"][class*="campaign"]')) return true;
    if (window.justuno || document.querySelector('[id^="ju_"]')) return true;
    if (window.MMG || document.querySelector('[class*="mailmunch"]')) return true;
    return false;
  }

  // ---- 7. Email popup ----
  function emailPopup(){
    if (CFG.skipPopups) return;
    if (thirdPartyPopupPresent()) return;
    var seen = sessionStorage.getItem('cro_email_seen');
    if (seen) return;
    var fired = false;
    function fire(){ if (fired) return; fired = true; sessionStorage.setItem('cro_email_seen','1'); show(); }
    setTimeout(fire, 15000);
    window.addEventListener('scroll', function(){
      var pct = (window.scrollY + window.innerHeight) / document.body.scrollHeight;
      if (pct > 0.30) fire();
    });
    function show(){
      var p = $('#cro-email-popup');
      if (p) p.classList.add('cro-show');
    }
  }

  // ---- 8. Exit intent popup ----
  function exitIntent(){
    if (CFG.skipPopups) return;
    if (thirdPartyPopupPresent()) return;
    if (!isPDP()) return;
    if (sessionStorage.getItem('cro_exit_seen')) return;
    document.addEventListener('mouseout', function(e){
      if (e.relatedTarget === null && e.clientY < 5) {
        sessionStorage.setItem('cro_exit_seen','1');
        var p = $('#cro-exit-popup');
        if (p) p.classList.add('cro-show');
      }
    });
  }

  // ---- 9. Sticky mobile add-to-cart ----
  function stickyATC(){
    if (!isPDP()) return;
    if (window.innerWidth > 768) return;
    if ($('#cro-sticky-atc')) return;
    var bar = document.createElement('div'); bar.id='cro-sticky-atc';
    var titleEl = $('h1.product__title') || $('h1');
    var priceEl = $('.price__regular .price-item') || $('[data-price]') || $('.price__sale') || $('.price');
    var t = (titleEl && titleEl.textContent ? titleEl.textContent : 'This product').trim().slice(0, 28);
    var p = (priceEl && priceEl.textContent ? priceEl.textContent : '').trim().slice(0, 12);
    bar.innerHTML = '<div class="cro-sk-l"><div class="cro-sk-t">'+t+'</div><div class="cro-sk-p">'+p+'</div></div><button class="cro-sk-btn">Add to cart</button>';
    document.body.appendChild(bar);
    bar.querySelector('button').onclick = function(){
      var realBtn = $('button[name="add"]'); if (realBtn) realBtn.click();
    };
    window.addEventListener('scroll', function(){
      bar.style.transform = window.scrollY > 420 ? 'translateY(0)' : 'translateY(120%)';
    });
  }

  // ---- 10. Recently bought toast ----
  function recentlyBoughtToast(){
    var female = (CFG.toastNamesFemale && CFG.toastNamesFemale.length) ? CFG.toastNamesFemale
      : ['Sophie','Emma','Olivia','Ava','Isabella','Mia','Charlotte','Amelia','Harper','Evelyn','Abigail','Emily','Camila','Luna','Sofia','Aria','Scarlett','Victoria','Madison','Layla'];
    var states = ['Texas','California','New York','Florida','Illinois','Ohio','Washington','Michigan','Georgia','Pennsylvania','Massachusetts','Arizona','Colorado','Oregon','North Carolina','New Jersey','Nevada','Minnesota','Tennessee','Virginia'];
    // Hardcoded fallback — all live Arvea products
    var liveProducts = ['The Taurus','The Scorpio','The Capricorn','The Aquarius','The Sagittarius','The Pisces','The Libra','The Gemini','The Aries','The Cancer','The Leo','The Virgo'];
    // Fetch live product titles so new products auto-appear in toasts
    fetch('/products.json?limit=250&fields=title')
      .then(function(r){ return r.json(); })
      .then(function(d){
        var titles = (d.products||[]).map(function(p){ return p.title; })
          .filter(function(t){ return t && !/pdf|guide|report|deck|printable|extender/i.test(t); });
        if (titles.length) liveProducts = titles;
      }).catch(function(){});
    var toast = document.createElement('div'); toast.id='cro-rb-toast';
    document.body.appendChild(toast);
    function show(){
      var name = female[Math.floor(Math.random()*female.length)];
      var state = states[Math.floor(Math.random()*states.length)];
      var product = liveProducts[Math.floor(Math.random()*liveProducts.length)];
      var mins = 1 + Math.floor(Math.random()*119);
      var timeStr = mins < 60 ? mins+' min ago' : Math.floor(mins/60)+'h'+(mins%60 ? ' '+mins%60+'m' :'')+' ago';
      toast.innerHTML = '<div class="cro-rb-name">'+name+' from '+state+'</div>'
        +'<div class="cro-rb-prod">just ordered <strong>'+product+'</strong></div>'
        +'<div class="cro-rb-time">'+timeStr+'</div>';
      toast.classList.add('cro-show');
      setTimeout(function(){ toast.classList.remove('cro-show'); }, 5500);
      // Next toast: random 15-60 seconds
      setTimeout(show, 15000 + Math.floor(Math.random()*45000));
    }
    // First toast: 8-15 seconds after page load
    setTimeout(show, 8000 + Math.floor(Math.random()*7000));
  }

  // ---- 11. Multi-source URL ?ref=instagram|tiktok|meta|reddit -> auto-apply discount ----
  function refDiscount(){
    var p = new URLSearchParams(location.search);
    var ref = p.get('ref');
    if (ref) sessionStorage.setItem('cro_ref', ref.toLowerCase());
    var saved = sessionStorage.getItem('cro_ref');
    var refCodes = CFG.refCodes || {};
    var code = saved && refCodes[saved] ? refCodes[saved] : (saved && CFG.refCode ? CFG.refCode : null);
    if (!code) return;
    window.__CRO_DISCOUNT__ = code;
    $$('form[action="/cart/add"]').forEach(function(f){
      if (f.dataset.croBound) return; f.dataset.croBound = '1';
      f.addEventListener('submit', function(){
        setTimeout(function(){ location.href='/discount/'+window.__CRO_DISCOUNT__+'?redirect=/checkout'; }, 700);
      });
    });
  }

  // ---- 12. Frequently bought together (PDP) ----
  // Adds all 3 items then applies BUNDLE10 discount code (10% off entire order)
  // before redirecting to cart. Bundle variant IDs are saved to sessionStorage
  // so bundleCartMonitor() can warn if the customer removes any item.
  function frequentlyBoughtTogether(){
    if (!isPDP()) return;
    if ($('#cro-fbt')) return;
    var handle = getProductHandle();
    if (!handle) return;
    var atcSection = $('button[name="add"]');
    if (!atcSection) return;
    var anchor = atcSection.closest('form') || atcSection.parentNode;
    if (!anchor) return;
    var bundleCode = CFG.bundleCode || 'BUNDLE10';
    fetch('/products/'+handle+'.js').then(function(r){return r.json();}).then(function(curr){
      fetch('/products.json?limit=24').then(function(r){return r.json();}).then(function(d){
        var all = (d && d.products) || [];
        var others = all.filter(function(p){
          return p.handle !== handle && p.images && p.images.length && p.variants && p.variants[0].price > 0;
        }).slice(0, 8);
        if (others.length < 2) return;
        var seed = hashStr(handle);
        var p1 = others[seed % others.length];
        var p2 = others[(seed+5) % others.length];
        if (!p1 || !p2 || p1.id === p2.id) return;
        var sum = (curr.price/100) + parseFloat(p1.variants[0].price) + parseFloat(p2.variants[0].price);
        var discounted = sum * 0.9;
        var box = document.createElement('div'); box.id='cro-fbt';
        box.innerHTML =
          '<h3>Frequently bought together</h3>' +
          '<div class="cro-fbt-row">' +
            '<div class="cro-fbt-tile"><img src="'+(curr.featured_image||'')+'"><div class="cro-fbt-name">'+curr.title.slice(0,28)+'</div></div>' +
            '<span class="cro-fbt-plus">+</span>' +
            '<div class="cro-fbt-tile"><img src="'+(p1.images[0].src||'')+'"><div class="cro-fbt-name">'+p1.title.slice(0,28)+'</div></div>' +
            '<span class="cro-fbt-plus">+</span>' +
            '<div class="cro-fbt-tile"><img src="'+(p2.images[0].src||'')+'"><div class="cro-fbt-name">'+p2.title.slice(0,28)+'</div></div>' +
          '</div>' +
          '<div class="cro-fbt-summary">' +
            '<div class="cro-fbt-price"><s>$'+sum.toFixed(2)+'</s> $'+discounted.toFixed(2)+' <span class="cro-fbt-badge">Save 10%</span></div>' +
            '<button class="cro-fbt-cta" data-cro-fbt-add>Add bundle, save 10%</button>' +
          '</div>';
        anchor.parentNode.insertBefore(box, anchor.nextSibling);

        box.querySelector('[data-cro-fbt-add]').onclick = function(){
          var btn = this;
          btn.disabled = true; btn.textContent = 'Adding...';
          var vid0 = curr.variants[0].id;
          var vid1 = p1.variants[0].id;
          var vid2 = p2.variants[0].id;
          // Persist bundle variant IDs so cart monitor can validate integrity
          try { sessionStorage.setItem('cro_bundle_vids', JSON.stringify([vid0, vid1, vid2])); } catch(_){}
          fetch('/cart/add.js', {
            method: 'POST',
            headers: {'Content-Type':'application/json'},
            body: JSON.stringify({items:[
              {id:vid0, quantity:1},
              {id:vid1, quantity:1},
              {id:vid2, quantity:1}
            ]})
          }).then(function(){
            // Apply discount code then land on cart
            location.href = '/discount/'+bundleCode+'?redirect=/cart';
          }).catch(function(){
            btn.disabled = false; btn.textContent = 'Add bundle, save 10%';
          });
        };
      }).catch(function(){});
    }).catch(function(){});
  }

  // ---- 12b. Bundle cart monitor (cart page only) ----
  // Polls cart every 4s. If the bundle from this session is incomplete
  // (some items removed), shows a warning banner. Clears when bundle
  // is restored OR when the session is abandoned.
  function bundleCartMonitor(){
    if (!isCart()) return;
    var raw = ''; try { raw = sessionStorage.getItem('cro_bundle_vids') || ''; } catch(_){}
    if (!raw) return;
    var bundleVids; try { bundleVids = JSON.parse(raw); } catch(_){ return; }
    if (!Array.isArray(bundleVids) || bundleVids.length < 2) return;

    var WARNING_ID = 'cro-bundle-warn';
    function ensureWarning(msg){
      var el = $('#'+WARNING_ID);
      if (!el){
        el = document.createElement('div'); el.id = WARNING_ID;
        var anchor = $('form[action="/cart"]') || $('main') || document.body;
        anchor.insertBefore(el, anchor.firstChild);
      }
      el.textContent = msg;
      el.style.display = msg ? 'block' : 'none';
    }

    function check(){
      fetch('/cart.js').then(function(r){return r.json();}).then(function(c){
        var inCart = (c.items||[]).map(function(i){ return i.variant_id; });
        var missing = bundleVids.filter(function(vid){ return inCart.indexOf(vid) === -1; });
        if (missing.length === 0){
          ensureWarning(''); // all good — clear any prior warning
        } else if (missing.length === bundleVids.length){
          // All items removed — bundle is gone, clear session data
          try { sessionStorage.removeItem('cro_bundle_vids'); } catch(_){}
          ensureWarning('');
        } else {
          ensureWarning('⚠️ Bundle incomplete — re-add all 3 items to keep your 10% discount.');
        }
      }).catch(function(){});
    }
    check();
    setInterval(check, 4000);
  }

  // ---- 13. Recently viewed carousel (PDP + homepage) ----
  function recentlyViewedTrack(){
    if (!isPDP()) return;
    var handle = getProductHandle();
    if (!handle) return;
    try {
      var raw = localStorage.getItem('cro_rv') || '[]';
      var list = JSON.parse(raw);
      list = list.filter(function(h){return h !== handle;});
      list.unshift(handle);
      list = list.slice(0, 12);
      localStorage.setItem('cro_rv', JSON.stringify(list));
    } catch(_){}
  }
  function recentlyViewedRender(){
    var raw = ''; try { raw = localStorage.getItem('cro_rv') || '[]'; } catch(_){}
    var list = []; try { list = JSON.parse(raw); } catch(_){ list = []; }
    var current = getProductHandle();
    list = list.filter(function(h){return h !== current;}).slice(0, 6);
    if (list.length < 2) return;
    if ($('#cro-rv')) return;
    var anchor = isPDP() ? $('main') : (document.querySelector('.product-grid') ? null : $('main'));
    if (!anchor) return;
    var c = document.createElement('div'); c.id='cro-rv'; c.className='cro-section';
    c.innerHTML = '<h3 class="cro-section-title">Recently viewed</h3><div class="cro-rv-row" data-cro-rv-row></div>';
    anchor.appendChild(c);
    var row = c.querySelector('[data-cro-rv-row]');
    list.forEach(function(h){
      fetch('/products/'+h+'.js').then(function(r){return r.json();}).then(function(p){
        if (!p || !p.title) return;
        var img = p.featured_image || (p.images && p.images[0]) || '';
        var price = p.price ? '$'+(p.price/100).toFixed(2) : '';
        var t = document.createElement('a'); t.className='cro-rv-tile'; t.href='/products/'+h;
        t.innerHTML = '<img src="'+img+'" alt="'+p.title+'"><div class="cro-rv-name">'+p.title+'</div><div class="cro-rv-price">'+price+'</div>';
        row.appendChild(t);
      }).catch(function(){});
    });
  }

  // ---- 14. Product badges (collection cards) ----

  // ---- 15. Cart drawer upsell at threshold ----
  function cartUpsell(){
    if (!isCart()) return;
    if ($('#cro-cart-upsell')) return;
    fetch('/cart.js').then(function(r){return r.json();}).then(function(c){
      var rem = CFG.threshold - c.total_price;
      if (rem <= 0) return;
      // Pull a candidate product (lowest priced)
      fetch('/products.json?limit=24').then(function(r){return r.json();}).then(function(d){
        var inCart = (c.items||[]).map(function(i){return i.product_id;});
        var pool = ((d && d.products) || []).filter(function(p){return inCart.indexOf(p.id) === -1 && p.variants && p.variants.length;});
        if (!pool.length) return;
        pool.sort(function(a,b){return parseFloat(a.variants[0].price) - parseFloat(b.variants[0].price);});
        var cand = pool[0];
        var price = '$'+parseFloat(cand.variants[0].price).toFixed(2);
        var anchor = $('form[action="/cart"]') || $('main') || document.body;
        var el = document.createElement('div'); el.id='cro-cart-upsell';
        el.innerHTML = '<span class="cro-cu-msg">Add <strong>'+cand.title+'</strong> ('+price+') to complete your set</span><button class="cro-cu-add" data-cro-cu-add data-vid="'+cand.variants[0].id+'">Add</button>';
        anchor.insertBefore(el, anchor.firstChild);
        el.querySelector('[data-cro-cu-add]').onclick = function(){
          var vid = this.getAttribute('data-vid');
          fetch('/cart/add.js', {method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({items:[{id:Number(vid),quantity:1}]})}).then(function(){ location.reload(); });
        };
      }).catch(function(){});
    }).catch(function(){});
  }

  // ---- 16. Email popup form handler ----
  function emailFormHandler(){
    var f = $('#cro-email-form'); if (!f) return;
    f.addEventListener('submit', function(e){
      e.preventDefault();
      var em = f.querySelector('input[type=email]'); if (!em || !em.value) return;
      try { localStorage.setItem('cro_email', em.value); } catch(_){}
      try {
        fetch('/api/subscribe', {method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({email:em.value, source:'cro_popup'})}).catch(function(){});
      } catch(_){}
      var msg = $('#cro-email-msg'); if (msg) msg.textContent = 'Code copied: '+CFG.welcomeCode+', applied at checkout';
      try { navigator.clipboard.writeText(CFG.welcomeCode); } catch(_){}
      setTimeout(function(){ var p=$('#cro-email-popup'); if (p) p.classList.remove('cro-show'); }, 2400);
    });
  }
  function exitFormHandler(){
    var b = $('#cro-exit-cta'); if (!b) return;
    b.addEventListener('click', function(){
      try { navigator.clipboard.writeText(CFG.exitCode); } catch(_){}
      var msg = $('#cro-exit-msg'); if (msg) msg.textContent = 'Code copied: '+CFG.exitCode;
      setTimeout(function(){ var p=$('#cro-exit-popup'); if (p) p.classList.remove('cro-show'); }, 1800);
    });
  }
  function popupClose(){
    $$('.cro-popup-close').forEach(function(b){
      b.addEventListener('click', function(){
        var pop = b.closest('.cro-popup'); if (pop) pop.classList.remove('cro-show');
      });
    });
  }

  // ---- Real review system ----
  var REVIEWS_API = 'https://arvea-command-center.vercel.app/api/reviews';

  function reviewSystem(){
    if (!isPDP()) return;
    if ($('#cro-review-section')) return;

    var handle = location.pathname.match(/\/products\/([^/?#]+)/);
    if (!handle) return;
    handle = handle[1];

    // ── Build star glyph string (same helper as stars()) ──────────────────
    function starGlyph(avg){
      var full = Math.floor(avg), half = (avg - full) >= 0.3 ? 1 : 0, empty = 5 - full - half;
      return '<span class="cro-rv-stars-glyph" aria-label="'+avg+' stars">' +
        '★'.repeat(full) + (half ? '½' : '') + '☆'.repeat(empty) + '</span>';
    }

    // ── Inject skeleton section first ────────────────────────────────────
    var section = document.createElement('div');
    section.id = 'cro-review-section';
    section.innerHTML = '<div id="cro-rv-loading" class="cro-rv-loading">Loading reviews...</div>';

    // Insert below product form (best anchor) or description
    var anchor = $('product-form') || $('form[action="/cart/add"]') ||
                 $('[class*="product__description"]') || $('main');
    if (anchor && anchor.parentNode) {
      anchor.parentNode.insertBefore(section, anchor.nextSibling);
    } else {
      ($('main') || document.body).appendChild(section);
    }

    // ── Fetch reviews ─────────────────────────────────────────────────────
    fetch(REVIEWS_API + '?handle=' + encodeURIComponent(handle))
      .then(function(r){ return r.json(); })
      .then(function(data){
        if (!data.ok) return;

        var reviews = data.reviews || [];
        var realCount = data.count || 0;
        var realAvg   = data.avg   || 0;

        // ── Update the star bar if real reviews exist ────────────────────
        if (realCount > 0){
          var starEl = $('#cro-stars');
          if (starEl){
            // Blend: weighted average of hardcoded base + real reviews
            var baseCountEl = starEl.querySelector('.cro-stars-count');
            var baseMatch = baseCountEl ? baseCountEl.textContent.match(/(\d+)/) : null;
            var baseCount = baseMatch ? parseInt(baseMatch[1]) : 80;
            var baseAvgEl = starEl.querySelector('.cro-stars-num');
            var baseAvg   = baseAvgEl ? parseFloat(baseAvgEl.textContent) : 4.7;

            var blendedCount = baseCount + realCount;
            var blendedAvg   = Math.round(
              ((baseAvg * baseCount) + (realAvg * realCount)) / blendedCount * 10
            ) / 10;

            starEl.querySelector('.cro-stars-count').textContent =
              '(' + blendedCount + ' verified buyers)';
            starEl.querySelector('.cro-stars-num').textContent = blendedAvg.toFixed(1);
            // Replace star glyph
            var glyphEl = starEl.querySelector('.cro-stars-glyph, .cro-rv-stars-glyph');
            if (glyphEl) glyphEl.outerHTML = starGlyph(blendedAvg);
          }
        }

        // ── Render reviews section ───────────────────────────────────────
        // Section header: if no real reviews yet, just show the write form
        // with a neutral heading so it doesn't clash with the existing star count above.
        var html = '<div class="cro-rv-hd">' +
          (realCount > 0 ? realCount + ' Customer Review' + (realCount !== 1 ? 's' : '') : 'Customer Reviews') +
          '</div>';

        // Review cards
        reviews.forEach(function(rv){
          var stars = '★'.repeat(rv.rating) + '☆'.repeat(5 - rv.rating);
          var date  = new Date(rv.created_at).toLocaleDateString('en-US', { month:'short', day:'numeric', year:'numeric' });
          html += '<div class="cro-rv-card">' +
            '<div class="cro-rv-stars">' + stars + '</div>' +
            (rv.title ? '<div class="cro-rv-title">' + escHtml(rv.title) + '</div>' : '') +
            '<div class="cro-rv-body">' + escHtml(rv.body) + '</div>' +
            '<div class="cro-rv-meta">' +
              '<span>' + escHtml(rv.author) + '</span>' +
              '<span>' + date + '</span>' +
              (rv.verified ? '<span class="cro-rv-verified">Verified Purchase</span>' : '') +
            '</div>' +
          '</div>';
        });

        // Review form
        html += '<div id="cro-rv-form">' +
          '<div class="cro-rv-fhd">Write a Review</div>' +
          '<div class="cro-rv-stars-pick" id="cro-rv-pick" data-val="0">' +
            '<span data-v="1">★</span><span data-v="2">★</span><span data-v="3">★</span>' +
            '<span data-v="4">★</span><span data-v="5">★</span>' +
          '</div>' +
          '<div class="cro-rv-row">' +
            '<input class="cro-rv-field" id="cro-rv-name"  placeholder="Your name" maxlength="60">' +
            '<input class="cro-rv-field" id="cro-rv-email" placeholder="Email (kept private)" type="email">' +
          '</div>' +
          '<input  class="cro-rv-field" id="cro-rv-title" placeholder="Review title" maxlength="120">' +
          '<textarea class="cro-rv-field" id="cro-rv-body"  placeholder="Tell us what you think..." rows="4" maxlength="2000" style="resize:vertical"></textarea>' +
          '<button class="cro-rv-submit" id="cro-rv-submit">Submit Review</button>' +
          '<div class="cro-rv-notice">Verified purchases are published immediately. Unverified reviews are approved within 24h.</div>' +
          '<div id="cro-rv-msg" style="display:none"></div>' +
        '</div>';

        section.innerHTML = html;

        // ── Star picker interaction ──────────────────────────────────────
        var picker = $('#cro-rv-pick');
        if (picker){
          var stars = picker.querySelectorAll('span');
          function highlightTo(n){
            stars.forEach(function(s){ s.classList.toggle('on', parseInt(s.dataset.v) <= n); });
          }
          stars.forEach(function(s){
            s.addEventListener('mouseover', function(){ highlightTo(parseInt(s.dataset.v)); });
            s.addEventListener('click', function(){
              picker.dataset.val = s.dataset.v;
              highlightTo(parseInt(s.dataset.v));
            });
          });
          picker.addEventListener('mouseleave', function(){
            highlightTo(parseInt(picker.dataset.val) || 0);
          });
        }

        // ── Form submission ──────────────────────────────────────────────
        var btn = $('#cro-rv-submit');
        var msg = $('#cro-rv-msg');
        if (btn){
          btn.addEventListener('click', function(){
            var rating = parseInt(picker ? picker.dataset.val : 0);
            var name   = ($('#cro-rv-name')  || {}).value || '';
            var email  = ($('#cro-rv-email') || {}).value || '';
            var title  = ($('#cro-rv-title') || {}).value || '';
            var body   = ($('#cro-rv-body')  || {}).value || '';

            if (!rating){ showMsg('Please select a star rating.', 'error'); return; }
            if (!name.trim()){ showMsg('Please enter your name.', 'error'); return; }
            if (!email.trim() || !email.includes('@')){ showMsg('Please enter a valid email.', 'error'); return; }
            if (!body.trim()){ showMsg('Please write a review.', 'error'); return; }

            btn.disabled = true;
            btn.textContent = 'Submitting...';

            fetch(REVIEWS_API, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                handle: handle,
                rating: rating,
                title:  title.trim(),
                body:   body.trim(),
                author_name: name.trim(),
                email:  email.trim(),
              }),
            })
            .then(function(r){ return r.json(); })
            .then(function(d){
              if (d.ok){
                var formEl = $('#cro-rv-form');
                if (formEl) formEl.innerHTML =
                  '<div class="cro-rv-success"><span class="cro-rv-success-icon">✓</span>' +
                  (d.pending
                    ? 'Thanks! Your review will appear after a quick check (usually within 24h).'
                    : 'Your review has been published!') +
                  '</div>';
              } else {
                btn.disabled = false;
                btn.textContent = 'Submit Review';
                showMsg(d.error === 'already reviewed' ? 'You have already reviewed this product.' : (d.error || 'Something went wrong.'), 'error');
              }
            })
            .catch(function(){
              btn.disabled = false;
              btn.textContent = 'Submit Review';
              showMsg('Connection error — please try again.', 'error');
            });
          });
        }

        function showMsg(txt, type){
          if (!msg) return;
          msg.textContent = txt;
          msg.style.display = 'block';
          msg.style.color = type === 'error' ? '#c0392b' : '#1a6e30';
          msg.style.marginTop = '8px';
          msg.style.fontSize = '13px';
        }
      })
      .catch(function(){
        section.innerHTML = ''; // fail silently
      });
  }

  function escHtml(str){
    return String(str || '').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
  }

  // ---- Sale badge injection ----
  // Dawn theme only renders the "Sale" badge for some products. This scans every
  // product card that already has the .price--on-sale class and stamps the same
  // badge on it if one isn't already there.
  function saleBadges(){
    if (!isCollection() && !isHome()) return;
    $$('.card-wrapper').forEach(function(card){
      // Only act on cards showing a sale price
      if (!card.querySelector('.price--on-sale')) return;
      // Skip if a Sale / sale badge already exists
      var badges = card.querySelectorAll('.badge');
      for (var i = 0; i < badges.length; i++){
        if (/^sale$/i.test(badges[i].textContent.trim())) return;
      }
      // Find the media element to attach the badge container
      var media = card.querySelector('.card__inner') || card.querySelector('.card__media');
      if (!media) return;
      // Reuse existing badge wrapper or create one
      var wrap = card.querySelector('.card__badge.bottom.left');
      if (!wrap){
        wrap = document.createElement('div');
        wrap.className = 'card__badge bottom left';
        media.appendChild(wrap);
      }
      var badge = document.createElement('span');
      badge.className = 'badge badge--bottom-left color-inverse';
      badge.textContent = 'Sale';
      wrap.appendChild(badge);
    });
  }

  function init(){
    try { countdownBar(); } catch(e){}
    /* freeShipBar disabled */
    try { trustBadges(); } catch(e){}
    try { stars(); } catch(e){}
    try { scarcity(); } catch(e){}
    try { inlineStockMerge(); } catch(e){}
    try { hideEmptyReviews(); } catch(e){}
    try { socialProof(); } catch(e){}
    try { emailPopup(); } catch(e){}
    try { exitIntent(); } catch(e){}
    try { stickyATC(); } catch(e){}
    try { recentlyBoughtToast(); } catch(e){}
    try { refDiscount(); } catch(e){}
    /* recently viewed disabled */
    try { frequentlyBoughtTogether(); } catch(e){}
    try { bundleCartMonitor(); } catch(e){}
    try { } catch(e){}
    try { reviewSystem(); } catch(e){}
    try { saleBadges(); } catch(e){}
    try { cartUpsell(); } catch(e){}
    try { emailFormHandler(); } catch(e){}
    try { exitFormHandler(); } catch(e){}
    try { popupClose(); } catch(e){}
    // Re-run a couple of the late-loading hooks because Shopify themes hydrate async
    setTimeout(function(){ try { inlineStockMerge(); } catch(e){} try { hideEmptyReviews(); } catch(e){} try { saleBadges(); } catch(e){} }, 1500);
    setTimeout(function(){ try { inlineStockMerge(); } catch(e){} try { hideEmptyReviews(); } catch(e){} try { saleBadges(); } catch(e){} }, 4000);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
